import pb from '../lib/pocketbase';

// Fetch a list of transportes with pagination
export async function getTransportes(page = 1, perPage = 10) {
  return await pb.collection('transporte').getList(page, perPage, {
    sort: '-created', // Sort by creation date in descending order
    $autoCancel: false,
    expand: 'relatedField' // Replace 'relatedField' with any field you want to expand
  });
}

// Fetch a single transporte by ID
export async function getTransporteById(id) {
  return await pb.collection('transporte').getOne(id);
}

// Create a new transporte
export async function createTransporte(transporte) {
  return await pb.collection('transporte').create(transporte);
}

// Update an existing transporte by ID
export async function updateTransporte(id, transporte) {
  return await pb.collection('transporte').update(id, transporte);
}

// Delete a transporte by ID
export async function deleteTransporte(id) {
  return await pb.collection('transporte').delete(id);
}